import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60662c04&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60662c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60662c04')) {
      api.createRecord('60662c04', component.options)
    } else {
      api.reload('60662c04', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=60662c04&scoped=true&", function () {
      api.rerender('60662c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/train/trainUsers/index.vue"
export default component.exports